// extracted by mini-css-extract-plugin
export var compact = "ServiceTile-module--compact--ec674";
export var service = "ServiceTile-module--service--86698";
export var serviceDisabled = "ServiceTile-module--service-disabled--e5e38";
export var serviceImage = "ServiceTile-module--service-image--f2979";
export var serviceLink = "ServiceTile-module--service-link--f57da";
export var serviceName = "ServiceTile-module--service-name--7fd9d";